import ApiService from '@/core/services/api.service';

const BASE_URL = 'preorder-programs';

const PreorderProgramService = {
  list() {
    return ApiService.query(BASE_URL);
  },
};

export default PreorderProgramService;
